const TR = {
  ibanLength: 26,
};
export { TR };
